import { render, staticRenderFns } from "./CommunicationList.vue?vue&type=template&id=227a3411&"
import script from "./CommunicationList.vue?vue&type=script&lang=js&"
export * from "./CommunicationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports